export default {
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '25px 50px 0px',
    textAlign: 'justify'
  }
};
